module.exports = __webpack_public_path__ + "media/qq1.9a0cb1f1.mp3";